<!--
 * @Author: Shen Kui
 * @Description: 对象信息
-->
<template>
  <div class="absolute h-[calc(100%-140px)] w-540px left-35px top-66px z-100">
    <el-tooltip
      :content="showPanel ? '收缩流向分析' : '展开流向分析'"
      placement="right"
      :open-delay="1000"
    >
      <div
        class="w-34px h-34px rounded-tl-2px rounded-tr-5px rounded-br-5px
          rounded-bl-2px bg-[#00c0ff] top-0px -left-34px text-center cursor-pointer absolute text-[#fff]"
        @click="showPanel = !showPanel"
      >
        <span class="iconfont icon-bg-setup text-18px !leading-34px"></span>
      </div>
    </el-tooltip>
    <div class="p-10px component-container h-full" v-show="showPanel">
      <div
        class="text-hex-fff text-24px h-46px w-full bg-no-repeat flex items-center py-10px px-10px"
      >
        流向分析
      </div>
      <div class="flex">
        <selectStandardId
          @updateStandardId="updateStandardId"
          class="!w-140px"
          :selectStandardProps="{ popperClass: 'document_select-popper' }"
        />
        <el-select
          class="w-full ml-10px flex-1"
          v-model="modelDocumentId"
          popper-class="document_select-popper"
          clearable
          filterable
          size="mini"
          placeholder="模型下拉选择"
          @change="changeCurrentModel"
        >
          <el-option
            v-for="item in modelList"
            :key="item.id"
            :label="item.fileNameOrigin"
            :value="item.documentId"
          ></el-option>
        </el-select>
      </div>
      <div class="flex mt-10px items-center">
        <el-input
          v-model="keyword"
          size="mini"
          class="mr-10px !w-140px"
          placeholder="请输入代码或名称"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-input
          v-model="medium"
          size="mini"
          class="mr-10px flex-1"
          placeholder="请输入介质"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="searchList"
            icon="iconfont icon-line-search"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="对象信息" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="$emit('showBitRelational')"
            icon="iconfont icon-bg-language"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="介质流向设置" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="openSetupDialog"
            icon="iconfont icon-bg-setup"
          ></el-button>
        </el-tooltip>
        <span class="whitespace-nowrap text-[#fff] ml-5px text-14px">流向动画</span>
        <el-switch
          class="ml-5px"
          v-model="allFlowStatus"
          :disabled="allFlowDisabled"
          @change="changeAllStatus"
          inactive-text-color="#fff"
          active-color="#3a8cf0"
        ></el-switch>
      </div>
      <div class="px-10px flex items-center text-[#fff] text-12px" v-show="!rootNodeVisible">
        <span class="mr-10px">透明度</span>
        <el-slider
          v-model="colorPickupBkAlpha"
          :min="0"
          :max="1"
          :step="0.1"
          class="w-full flex-1"
        />
      </div>
      <el-table
        ref="markerTable"
        :data="tableData"
        v-loading="tableLoading"
        :height="allFlowStatus ? 'calc(100% - 216px)' : 'calc(100% - 178px)'"
        :row-key="(row) => row.tagId"
        class="mt-10px"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
        @row-click="moveToPipe"
      >
        <el-table-column type="selection" width="50" reserve-selection></el-table-column>
        <el-table-column show-overflow-tooltip prop="tagCode" label="代码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tagName" label="名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="medium" label="介质"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="discipline" label="专业"></el-table-column>
      </el-table>
      <div class="mt-10px text-right">
        <el-pagination
          small
          background
          @current-change="getTableData"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="setupDialogVisible"
      title="介质流向设置"
      width="500px"
      :modal="false"
      v-dialogDrag
    >
      <el-table
        :data="mediumData"
        v-loading="mediumLoading"
        height="300px"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column show-overflow-tooltip prop="key" label="介质"> </el-table-column>
        <el-table-column show-overflow-tooltip label="流向贴图">
          <template slot-scope="scope">
            <el-select
              class="w-full"
              v-model="scope.row.value"
              popper-class="document_select-popper"
              clearable
              filterable
              size="mini"
              placeholder="流向贴图"
            >
              <el-option
                v-for="(item, index) in sourceList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="text-center">
        <el-button size="small" type="primary" @click="saveSetup">保存</el-button>
        <el-button size="small" @click="setupDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ThreeDimensionsService from '@/services/ThreeDimensions'
import ApiMixinDocument from '@/assets/js/api/documents'
import selectStandardId from '@/modules/resource/components/selectStandardId'
import { addFlowAnimation } from '../js/publicModelMays'

export default {
  name: 'pipeExtraction',
  mixins: [ApiMixinDocument],
  components: {
    selectStandardId,
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      showPanel: true,
      standardId: localStorage.getItem('standardId'),
      modelDocumentId: '',
      modelList: [], // 模型列表
      keyword: '',
      medium: '',
      allModelList: [], // 所有模型列表
      currentSelectedPipe: [], // 表格多选
      colorPickupBkAlpha: 0.7,
      allFlowDisabled: true,
      allFlowStatus: false, // 批量流向动画展示
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      rootNodeVisible: true,
      currentPipeActions: [], // 当前已经创建的动画
      orginPipeNodes: [], // 原始节点
      setupDialogVisible: false,
      mediumData: [],
      mediumLoading: false,
      sourceList: [],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  watch: {
    colorPickupBkAlpha: {
      async handler(val) {
        await this.renderVignette(val)
      },
    },
    player: {
      immediate: true,
      async handler(val) {
        if (val) {
          const source = await player.Native.File.findFile(
            `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/dynamic/pipeFlow`,
            '*'
          )
          this.sourceList = source.filter((item) => {
            return !item.includes('.')
          })
        }
      },
    },
  },
  methods: {
    openSetupDialog() {
      this.setupDialogVisible = true
      this.getMediumData()
    },
    async saveSetup() {
      const res = await ThreeDimensionsService.updateMedium({
        standardId: this.standardId,
        items: this.mediumData,
      })
      if (res?.code === 0) {
        this.$message.success('保存成功')
        this.setupDialogVisible = false
      }
    },
    searchList() {
      this.page.pageNo = 1
      this.resetData()
      this.getTableData()
    },
    // 获取管线表数据
    async getTableData() {
      this.tableData = []
      this.tableLoading = true
      const res = await ThreeDimensionsService.getPipeLineList({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        standardId: this.standardId,
        modelFileId: this.modelDocumentId
          ? _.find(this.modelList, ['documentId', this.modelDocumentId]).fileIdOrigin
          : '',
        filter: this.keyword,
        medium: this.medium,
      })

      if (res?.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 重置数据
    async resetData() {
      this.allFlowDisabled = true
      this.allFlowStatus = false
      this.rootNodeVisible = true
      this.changeAllStatus(this.allFlowStatus)
      this.currentPipeActions = [] // 清空动画列表
      this.currentSelectedPipe = [] // 清空多选
      this.tableData = []
      this.$refs.markerTable?.clearSelection()
    },
    // 表格多选
    handleSelectionChange(val) {
      this.currentSelectedPipe = val
      this.resetSwitchStatus()
    },
    updateStandardId(val) {
      this.standardId = val
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
    },
    // 切换模型
    async changeCurrentModel(val) {
      // 获取model详情
      const model = await this.getModelFileDetail(val)
      if (!_.isEmpty(model)) {
        this.$emit('changeModelData', model)
      }
      await this.getMediumData()
      this.searchList()
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getModelFileDetail(id) {
      const res = await DocumentManagementService.getDocumentDetail({
        id,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        if (_.isEmpty(fileDetail)) {
          return {}
        }
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        fileDetail.classId = res.data.documentBaseInfo.classId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.last(_.split(fileDetail.fileName, '.')).toLowerCase()
        return fileDetail
      }
      return {}
    },
    async getModelList() {
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          id: this.documentId,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data
      }
      return []
    },
    // 当单个管线的按钮状态切换时，调整总体抽离开关状态
    resetSwitchStatus() {
      if (this.currentSelectedPipe?.length) {
        this.allFlowDisabled = false
        const codeWithAnimation = _.map(this.currentPipeActions, (item) => {
          return item.code
        })
        let hasNoAnimationPipe = false
        // 判断多选项里是否有还未加载动画的管线
        try {
          _.forEach(this.currentSelectedPipe, (item) => {
            if (!codeWithAnimation.includes(item.tagCode)) {
              hasNoAnimationPipe = true
              // throw new Error()
            }
          })
        } catch (e) {
          console.log(e)
        }
        if (hasNoAnimationPipe) {
          // 有未打开抽离的管线、将状态改为false
          this.allFlowStatus = false
        } else {
          // 无未打开的抽离，则按钮为true，可执行关闭操作
          this.allFlowStatus = true
        }
      } else {
        this.allFlowDisabled = true
      }
    },
    async markerHover(item) {
      const newimgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,127')
      if (item.markerId !== 0) {
        await this.player.Native.GisMarker.setProperty(item.markerId, {
          imgId: newimgId,
          textColor: 0xffffffff,
        })
      }
    },
    async markerLeave(item) {
      // 创建一个透明的图片，用于隐藏
      const imgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,0')
      await this.player.Native.GisMarker.setProperty(item.markerId, {
        imgId,
        textColor: 0xffffff00,
      })
    },
    // 全量修改抽离状态
    async changeAllStatus(val) {
      if (_.isEmpty(this.player)) return
      // 首先将选中的模型节点取消选中
      const hiddenNodes = await this.player.Native.Node.getSeletedNodes()
      if (hiddenNodes && !_.isEmpty(hiddenNodes)) {
        await this.player.Native.Node.unSelectNodes(hiddenNodes)
      }
      setTimeout(async () => {
        const rootNode = await this.player.Native.Node.getRoot()
        if (!rootNode) return
        if (val) {
          this.$emit('loadingSwitch', { bol: true, title: '动画加载中' })
          try {
            // 新增：关闭所有现有动画节点
            if (this.currentPipeActions.length > 0) {
              // 销毁所有动画节点
              await this.player.Native.Node.destroy(
                this.currentPipeActions.map((e) => {
                  return e.node
                })
              )
              // 显示所有原始节点
              await this.player.Native.Node.setProperty(
                this.orginPipeNodes.map((e) => {
                  return e.node
                }),
                { visible: true }
              )
              // 清空状态数组
              this.currentPipeActions = []
              this.orginPipeNodes = []
            }
            // 原有的开启动画逻辑
            if (this.rootNodeVisible) {
              await this.player.Native.Setting.set('display.bgTransparent.enable', true)
              await this.player.Native.Setting.set('display.pickup.fillColor.enable', false)
              this.rootNodeVisible = false
            }
            // 处理当前选中的管线
            const codeCol = this.currentSelectedPipe.map((e) => {
              return e.tagCode
            })
            const codeInfoCol = await this.player.Native.Node.findNode(rootNode, { codes: codeCol })
            if (codeInfoCol?.codes && !_.isEmpty(codeInfoCol.codes)) {
              const nodeCol = Object.values(codeInfoCol.codes).map((e) => {
                return e.node
              })
              const existCodeNodeList = await this.player.Native.Node.getProperty(nodeCol, [
                'code',
                'parent',
              ])
              const nodeList = await this.filterNodeList(
                existCodeNodeList,
                this.currentSelectedPipe
              )
              const cloneNodeList = await addFlowAnimation(this.player, nodeList)
              if (cloneNodeList?.length) {
                this.currentPipeActions.push(...cloneNodeList)
                await this.player.Native.Node.setProperty(
                  nodeList.map((e) => {
                    return e.node
                  }),
                  { visible: false }
                )
                this.orginPipeNodes.push(...nodeList)
              }
            }

            await this.renderVignette(this.colorPickupBkAlpha)
            if (this.currentPipeActions.length > 0) {
              this.moveToPipe({ tagCode: this.currentPipeActions[0].code })
            }
            this.$emit('loadingSwitch', { bol: false, title: '动画加载中' })
            const codeList = _.map(this.currentSelectedPipe, 'tagCode')
            this.player.Native.GisMarker.EventGisMarkerHover.connect(this.markerHover)
            this.player.Native.GisMarker.EventGisMarkerLeave.connect(this.markerLeave)
            const createMarkerFunc = _.map(codeList, (code) => {
              return new Promise(async (resolve) => {
                const nodeResult = await this.cloudRender.NodeProxy.getInfo('Code', code)
                if (nodeResult.status) {
                  const nodeInfo = nodeResult.data.nodeInfo
                  const text = `Code: ${nodeInfo.code}`
                  const aabb = nodeInfo.aabb
                  const pos = []
                  pos[0] = aabb[0][0] + (aabb[1][0] - aabb[0][0]) * 0.5 // x坐标
                  pos[1] = aabb[0][1] + (aabb[1][1] - aabb[0][1]) * 0.5 // y坐标
                  pos[2] = aabb[0][2] + (aabb[1][2] - aabb[0][2]) // z坐标
                  await this.cloudRender.Marker.createBySingleLine({
                    id: code,
                    pos,
                    background: 'transparent',
                    visible: true,
                    text,
                    textColor: '#ffffffff',
                    nodeOffset: [0, -60],
                    markPosType: 1,
                  })
                }
                resolve()
              })
            })
            await Promise.all(createMarkerFunc)
          } catch (error) {
            this.$message.warning('建模节点不包含Pipe，无法创建动画')
            this.$emit('loadingSwitch', { bol: false, title: '动画加载中' })
          }
        } else {
          // 关闭所有动画节点
          if (this.currentPipeActions.length > 0) {
            await this.player.Native.Node.destroy(
              this.currentPipeActions.map((e) => {
                return e.node
              })
            )
            await this.player.Native.Node.setProperty(
              this.orginPipeNodes.map((e) => {
                return e.node
              }),
              { visible: true }
            )
            this.currentPipeActions = []
            this.orginPipeNodes = []
          }
          // 调整透明度为1之后再将模式改为轮廓线
          await this.renderVignette(1)
          this.player.Native.Setting.set('display.bgTransparent.enable', false)
          await this.player.Native.Setting.set('display.pickup.fillColor.enable', true)
          await this.cloudRender.Marker.destroyAllMarker()
          this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
          this.player.Native.GisMarker.EventGisMarkerLeave.disconnect(this.markerLeave)
          this.rootNodeVisible = true
        }
      }, 1000)
    },
    /**
     * @description 批量整理node信息
     * @param {Array} nodeList 模型种存在的node列表
     * @param {Array} selectPipes 当前选中里欸包
     * @returns {*}
     */
    filterNodeList(nodeList, selectPipes) {
      let res = []
      const temp = _.map(selectPipes, (item) => {
        const direction = !!(item.direction === '正')
        let materialType = 'trueWhile'
        const materialIndex = _.findIndex(this.mediumData, ['key', item.medium])
        if (materialIndex > -1) {
          materialType = this.mediumData[materialIndex].value
        }
        const index = _.findIndex(nodeList, ['code', item.tagCode])
        if (index > -1) {
          return {
            code: item.tagCode,
            node: nodeList[index].node,
            parent: nodeList[index].parent,
            direction,
            materialType,
          }
        }
        return {}
      })
      res = _.filter(temp, (item) => {
        return !_.isEmpty(item)
      })
      return res
    },
    async renderVignette(val) {
      if (_.isEmpty(this.player)) return
      // 调整alpha通道值
      await this.player.Native.Setting.set('display.bgTransparent.alpha', val)
      // 选中表格中勾选的模型节点
      const rootNode = await this.player.Native.Node.getRoot()
      if (!rootNode) return
      const codeInfoCol =
        this.currentPipeActions && this.currentPipeActions.length > 0
          ? {
              codes: this.currentPipeActions,
            }
          : await this.player.Native.Node.findNode(rootNode, {
              codes: _.map(this.currentSelectedPipe, 'tagCode'),
            })
      if (codeInfoCol?.codes && !_.isEmpty(codeInfoCol.codes)) {
        const nodeCol = _.map(Object.values(codeInfoCol.codes), 'node')
        await this.player.Native.Node.selectNodes(nodeCol)
      }
    },
    async moveToPipe(row) {
      if (row.tagCode) {
        this.$emit('getModelData', {
          isTag: true,
          businessId: row.tagId,
          code: row.tagCode,
          codeChangeType: 'pickUpengineId', // 避免触发ModelView中的moveCamera，动画节点会覆盖原始节点导致选中不生效
        })
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [row.tagCode],
        })
        const codes = codeData?.codes
        if (codes && codes[row.tagCode] && codes[row.tagCode].node) {
          // 计算节点包围盒
          const nodeInfo = await this.player.Native.Node.getProperty(codes[row.tagCode].node, [
            'aabb',
          ])
          const calculateValue = (aabb) => {
            const minPoint = aabb[0]
            const maxPoint = aabb[1]

            const dx = maxPoint[0] - minPoint[0]
            const dy = maxPoint[1] - minPoint[1]
            const dz = maxPoint[2] - minPoint[2]

            const L = Math.sqrt(dx ** 2 + dy ** 2 + dz ** 2)
            const value = 0 + 6.5 / (1 + Math.log(L + 1))
            return value
          }
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToAabbWithDistance(
            nodeInfo.aabb,
            2,
            25,
            calculateValue(nodeInfo.aabb)
          )
          if (!this.rootNodeVisible) {
            // const codeInfoCol =
            //   this.currentPipeActions && this.currentPipeActions.length > 0
            //     ? {
            //         codes: this.currentPipeActions,
            //       }
            //     : await this.player.Native.Node.findNode(rootNode, {
            //         codes: _.map(this.currentSelectedPipe, 'tagCode'),
            //       })
            // if (codeInfoCol?.codes && !_.isEmpty(codeInfoCol.codes)) {
            //   const nodeCol = _.map(Object.values(codeInfoCol.codes), 'node')
            //   await this.player.Native.Node.selectNodes(nodeCol)
            // }
          } else this.player.Native.Node.selectNodes([codes[row.tagCode].node])
        }
      }
    },
    async getMediumData() {
      this.mediumLoading = true
      const res = await ThreeDimensionsService.getMediumMaps({
        standardId: this.standardId,
      })
      this.mediumLoading = false
      if (res?.code === 0) {
        this.mediumData = res.data
      }
    },
  },
  async created() {
    this.allModelList = await this.getModelList()
    if (this.standardId) {
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
    }
  },
  async beforeDestroy() {
    if (this.currentPipeActions.length) {
      await this.player.Native.Node.destroy(_.map(this.currentPipeActions, 'node'))
    }
    const rootNode = await this.player.Native.Node.getRoot()
    if (rootNode) {
      await this.player.Native.Node.setProperty(rootNode, { visible: true })
      this.rootNodeVisible = true
    }
  },
}
</script>

<style lang="scss" scoped>

@import '../../documentBrowseVk/css/index.scss';

.component-container,
::v-deep .el-dialog {
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}
::v-deep .el-dialog {
  background-color: transparent !important;
  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom-color: #0680e9;
    .el-dialog__title {
      font-size: 24px;
      line-height: 40px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff !important;
    }
  }
  .el-dialog__footer {
    background-color: transparent;
    border-top-color: #0680e9;
  }
}

</style>
